import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hd"}/>
}
